import React, { Fragment } from 'react';

// This "page" is an entry point to CAJA
// It's used to initialise the flow via hooks in the createFlowContainer and renders nothing
export const CreatePage = () => <Fragment />;
